import { httpPut } from '../../../../Util/http';
import { addAlert } from '../../../../MsgNotify/msgNotifyActions';


export const SAVE_SIGNATURE_REQUEST = 'SAVE_SIGNATURE_REQUEST'
export const saveSignatureRequest = () => (
    {
        type: SAVE_SIGNATURE_REQUEST
    }
)

export const SAVE_SIGNATURE_SUCCESS = 'SAVE_SIGNATURE_SUCCESS'
export const saveSignatureSuccess = (formData, dateOfSignature) => (
    {
        type: SAVE_SIGNATURE_SUCCESS,
        signature: {...formData, dateOfSignature}
    }
)

export const SAVE_SIGNATURE_FAILURE = 'SAVE_SIGNATURE_FAILURE'
export const saveSignatureFailure = () => (
    {
        type: SAVE_SIGNATURE_FAILURE
    }
)

export const saveSignature = (formData) => {
  var url = process.env.REACT_APP_webApiEndPoint + "api/dailyreport/sign";
  return dispatch => {
    dispatch(saveSignatureRequest());
    httpPut(url, formData)
    .then(
      ()=>dispatch(saveSignatureSuccess(formData, new Date())))
    .catch(()=>{
      dispatch(saveSignatureFailure());
      dispatch(addAlert("kunne ikke gemme underskrift, prøv igen"));
    });
  }
}


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Signature/actions.js